











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import BillApi from '@/api/bill'
import LawyerApi from '@/api/lawyer'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import PageLayout from '@/components/page/PageLayout.vue'
import { uuid, dateFormat, throttle, download } from '@/utils/util'
import moment from 'moment'
import EvaluateApi from '@/api/evaluate'
import investTabs from '@/views/investigate/Tabs.vue'
import Task from '@/web-task'
import { triggerWindowResizeEvent } from '@/utils/util'
import cloneDeep from 'lodash/cloneDeep'
import { initOrderDetail } from '@/web-task/utils/order'
import { wsURL } from '@/api/url'
import setting from '@/core/setting'
import InvestigateApi from '@/api/investigate'
import Info from '@/components/task/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import { formatTime, formatDate, format } from '@/web-task/filter'
import { zeroUnit } from '@/web-task/utils'
import ImageList from '@/views/AiiTasks/ImageList.vue'
import { updateViewer } from '@/utils/util'
import OrderList from './OrderList.vue'

let viewer: any = ''

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'lawyerDetail',
	components: {
		PageLayout,
		investTabs,
		Info,
		InfoRow,
		ImageList,
		OrderList,
	},
})
export default class QueryList extends Vue {
	private addResurveyVisible: boolean = false
	private taskLog: any = []
	private taskLogVisible: boolean = false
	private order: any = ''
	private invoices: any = ''
	private injured: any = ''
	private task: any = {}
	private exporting: boolean = false
	private active: any = 0
	private lawyer: any = ''
	private mediaInfoList: any = []

	private get lawyerInfo() {
		return {
			title: '律师信息',
			children: [
				{ label: '姓名', value: this.lawyer.name },
				{
					label: '性别',
					value: this.$store.state.setting.sexMap[this.lawyer.sex],
				},
				{ label: '联系方式', value: this.lawyer.mobile },
				{ label: '执业执照', value: this.lawyer.license },
				{ label: '律所名称', value: this.lawyer.lawOffice },
				{ label: '执业地区', value: this.lawyer.fullDesc },
				{ label: '擅长领域', value: this.lawyer.brief },
				{ label: '综合得分', value: this.lawyer.score },
			],
		}
	}

	private init() {
		this.order = ''
		this.invoices = ''
		this.getDetail()
	}

	private toggle() {
		if (this.lawyer.status === '1') {
			this.$confirm({
				title: '提示',
				content: '确认停用吗 ?',
				onOk: () => {
					const form = {
						visitorId: this.$route.params.id,
					}
					return LawyerApi.inactiveLawyer(form).then((res: any) => {
						this.$message.success('停用成功')
						this.getDetail()
					})
				},
			})
		} else {
			this.$confirm({
				title: '提示',
				content: '确认启用吗 ?',
				onOk: () => {
					const form = {
						visitorId: this.$route.params.id,
					}
					return LawyerApi.activeLawyer(form).then((res: any) => {
						this.$message.success('启用成功')
						this.getDetail()
					})
				},
			})
		}
	}

	private activated() {
		this.init()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.init()
		})
		next()
	}

	private getDetail() {
		return LawyerApi.getDetail(this.$route.params.id).then((res: any) => {
			this.lawyer = res.data
			this.mediaInfoList = [
				{
					picName: '正装照',
					picUrl: this.lawyer.picUrl,
				},
			]
			if (this.lawyer.identification) {
				this.mediaInfoList.push({
					picName: '身份证照',
					picUrl: this.lawyer.identification,
				})
			}
			this.$nextTick(() => {
				viewer = updateViewer(viewer, '#images')
			})
		})
	}

	private deactivated() {
		viewer && viewer.destroy()
		viewer = ''
	}
}
